import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import { LISTING_HEAP_IDS } from '../../../constants';
import './ActionsPanel.scss';

type ActionsPanelProps = {
    isShareable: boolean;
    isEnded: boolean;
    isSalesEndedListingExperimentEnabled: boolean;
};

export const ActionsPanel = ({
    isShareable,
    isEnded,
    isSalesEndedListingExperimentEnabled,
}: ActionsPanelProps) => {
    const canBeShared = isShareable && !isEnded;

    const panelItemsClassNames = classNames(
        'actions-panel__item eds-fx--fade-in-down',
        { 'eds-fx--duration-2 fx--delay-14 z-1': !canBeShared },
        {
            'actions-panel__item--share eds-fx--duration-1 fx--delay-12':
                canBeShared,
        },
        {
            'listings_icons--margin-bottom':
                isSalesEndedListingExperimentEnabled,
        },
    );

    return (
        <div className="actions-panel">
            <h2 className="eds-is-hidden-accessible">
                {gettext('Actions Panel')}
            </h2>
            <ul className="actions-panel__list">
                <li className={panelItemsClassNames}>
                    <span id="listings-root__bookmark-desktop"></span>
                </li>
                {canBeShared && (
                    <li
                        data-heap-id={LISTING_HEAP_IDS.SHARE_EVENT}
                        className={panelItemsClassNames}
                    >
                        <span id="listings-root__share-event-modal"></span>
                    </li>
                )}
            </ul>
        </div>
    );
};
